import styled from "styled-components";

const StyledContainer = styled.section`
    width: 100%;
    padding: 40px 10px;
    background: linear-gradient(135deg, #aaccff, #ddeeff);
    box-sizing: border-box;
`;

const StyledBlock = styled.div`
    max-width: 700px;
    margin: 30px auto;
    padding: 30px 20px;
    background-color: #f0f0f0;
    border-radius: 10px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
`;

const StyledHeading = styled.h1`
    text-align: center;
    font-size: 32px;
    margin-bottom: 15px;
    color: #007acc;
    font-weight: bold;
`;

const StyledText = styled.div`
    font-size: 16px;
    line-height: 1.5;
    color: #2b2b2b;

    p {
        margin-bottom: 15px;
    }

    a {
        color: #007acc;
        text-decoration: none;
        font-weight: 500;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const CookiePolicy = () => {
  return (
    <StyledContainer>
      <StyledBlock>
        <StyledHeading>Datenschutzrichtlinie von Troniq.news</StyledHeading>
        <StyledText>
          <p>
            Bei Troniq.news schätzen wir Ihre Privatsphäre und verpflichten uns, Ihre persönlichen Informationen zu schützen. Unsere Datenschutzrichtlinie erklärt, wie wir Ihre Daten während Ihrer Besuche auf unserer Plattform sammeln, verwenden und sichern.
          </p>
          <p>
            Wir können Cookies und ähnliche Technologien verwenden, um Ihr Surferlebnis zu verbessern, den Website-Verkehr zu bewerten und den Inhalt gemäß Ihren Vorlieben anzupassen. Wenn Sie weiterhin unsere Plattform nutzen, stimmen Sie unserer Datenschutzrichtlinie zu.
          </p>
          <p>
            Sie können Cookies über die Einstellungen Ihres Browsers verwalten oder löschen, wobei dies die Funktionalität und Personalisierung unserer Plattform beeinträchtigen kann.
          </p>
          <p>
            Für weitere Details konsultieren Sie bitte unsere{" "}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Datenschutzrichtlinie
            </a>.
          </p>
        </StyledText>
      </StyledBlock>
    </StyledContainer>
  );
};
export default CookiePolicy;